"use strict";
/*
 * Created on 12 20 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var SelloutIdentificationFilterConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutIdentificationFilterConverter, _DataObjectConverter_);

  function SelloutIdentificationFilterConverter() {
    _classCallCheck(this, SelloutIdentificationFilterConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutIdentificationFilterConverter).apply(this, arguments));
  }

  return SelloutIdentificationFilterConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutIdentificationFilterConverter = SelloutIdentificationFilterConverter;